import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useDevicesAvailable = (): IGlobalStore['devices_available'] => {
  return useSelector((store: IReducerStore) => store.global.devices_available);
};
